import React from 'react';
import PrintDialog from '@/components/shared/PrintDialog';

export interface PrintModalProps {
    isOpen: boolean;
    onClose: () => void;
    children: React.ReactNode;
    title?: string;
    documentTitle?: string;
    orientation?: 'portrait' | 'landscape';
}

export function PrintModal({ isOpen, onClose, children, title = "In biểu mẫu", documentTitle = "Document", orientation = "portrait" }: PrintModalProps) {
    return (
        <PrintDialog 
            open={isOpen} 
            onClose={onClose} 
            type="custom" 
            orientation={orientation} 
            documentTitle={documentTitle}
        >
            {children}
        </PrintDialog>
    );
}
